import { apiGet, apiPut } from '../services/apiClient';

export const getAdminPartialPaymentSettings = async (token) =>
  apiGet('/api/admin/partial-payment/settings', token);

export const saveAdminPartialPaymentSettings = async (token, payload) =>
  apiPut('/api/admin/partial-payment/settings', payload, token);

export const listAdminPartialPaymentProperties = async (token, params = {}) => {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') qs.set(key, value);
  });
  return apiGet(`/api/admin/partial-payment/properties${qs.toString() ? `?${qs}` : ''}`, token);
};

export const saveAdminPropertyPartialPayment = async (token, propertyId, payload) =>
  apiPut(`/api/admin/partial-payment/properties/${encodeURIComponent(propertyId)}`, payload, token);
